import Banner from "./banner";
import './index.less'
export default Banner